const analyticsConstants = {
  FETCH_LEARNERS: 'FETCH_LEARNERS',
  FETCH_COURSES_STATS_SUCCESS: 'FETCH_COURSES_STATS_SUCCESS',
  LEARNER_PROGRESS_FILTERS: 'LEARNER_PROGRESS_FILTERS',
  COURSE_PROGRESS_FILTERS: 'COURSE_PROGRESS_FILTERS',
};

export default analyticsConstants;
